import { controls } from "../../controls";

const rp1018 = {
  label: "MSEB Division",
  pageLabel: "MSEB Division",
  starting: true,
  url: "rp1018",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [


    ...controls.magicDateLabel({ tab: "Filter", label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "date_to_dueration", width: "col-sm-2", convertedTo:"return_duration",dateType:"ontype", }),
    ...controls.showData({tab:"filter",data: "return_duration", name: "return_duration",width:"col-sm-2"}),

    ...controls.magicDateLabel({ tab: "filter", label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "date_to_dueration", width: "col-sm-2", convertedTo:"return_duration",dateType:"ontype", }),
    ...controls.showData({tab:"filter",data: "return_duration", name: "return_duration",width:"col-sm-2"}),
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "MSEB Division Summary ",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
//clickable: true, 
    displayColumns: [
      {
        Header: "Division Code",
        accessor: "division_code",
//        width: 180,
      //  rwidth: 100
      },
      {
        Header: "Division Name",
        accessor: "division_name",
  //      width: 130,
      //  rwidth: 75
      },
      {
        Header: "Opening",
        accessor: "opening",
    //    width: 130,
      //  rwidth: 75
      },
      {
        Header: "Credit",
        accessor: "credit",
        type:"currency",
      //  width: 100,
       // rwidth: 120
      },
      {
        Header: "Debit",
        accessor: "debit",
        type:"currency",
      //  width: 100,
       // rwidth: 120
      },
      {
        Header: "Closing",
        accessor: "closing",
       // width: 100,
        //rwidth: 120
      }
    ]
  }
};

export default rp1018;